/**
 * @generated SignedSource<<638fe57df0f0306785938d443217587f>>
 * @relayHash dbb4fc405135e8a7a440f4a278aa8a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectListRightPanelState = "CLOSED" | "OPEN" | "%future added value";
export type src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$variables = {
  cloudId: string;
  isAllowingEndUsersToAccessCustomTemplates: boolean;
  isAnonymous: boolean;
};
export type src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$data = {
  readonly jira?: {
    readonly canCreateProject: boolean | null | undefined;
    readonly shouldDisplay?: boolean | null | undefined;
    readonly sidebarExperimentTemplates: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly userPreferences: {
      readonly projectListRightPanelState: JiraProjectListRightPanelState | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList">;
  } | null | undefined;
};
export type src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery = {
  response: src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$data;
  variables: src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAllowingEndUsersToAccessCustomTemplates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "projectListRightPanelState"
},
v6 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "experimentKey",
    "value": "sidebarExperiment"
  }
],
v7 = {
  "alias": "sidebarExperimentTemplates",
  "args": (v6/*: any*/),
  "concreteType": "JiraProjectListViewTemplateConnection",
  "kind": "LinkedField",
  "name": "projectListViewTemplates",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalCount"
    }
  ]
},
v8 = {
  "alias": "canCreateProject",
  "args": [
    (v3/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": "CREATE_PROJECT"
    }
  ],
  "kind": "ScalarField",
  "name": "canPerform"
},
v9 = {
  "condition": "isAllowingEndUsersToAccessCustomTemplates",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "shouldDisplay",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "VIEW_PROJECT_CREATION_ENTRY"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectListViewTemplateItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "templateType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "productKey"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isProductLicensed"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "shortDescription"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPremiumOnly"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canCreate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "recommendationSessionId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "iconDarkUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "previewUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "previewDarkUrl"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51",
    "metadata": {},
    "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "021e8fae3a719490c175d29ba166dc66";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
